export default {
  getModelsOptRelatedProducts(state, getters, rootState) {
    const modelsOpt = rootState.account.newOrder.modelsOpt;

    if (modelsOpt) {
      const models = modelsOpt.find(el => el.id === state.system.id);

      if (models) {
        const id = Object.keys(state.materials);

        return models.sub_categories.filter(el => id.includes(el.id));
      }
    }

    return [];
  },
}
